import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBreakthroughFuelDetail extends Layout {
    checkboxOnHold: Checkbox;
    sourceBreakthroughTransaction: DataSource;
    textboxCarrierRefs: Textbox;
    textboxCarrierScac: Textbox;
    textboxComments: Textbox;
    textboxCustomerId: Textbox;
    textboxDownloadDate: Textbox;
    textboxFuelSurcharge: Textbox;
    textboxLoadTenderRef: Textbox;
    textboxOrderId: Textbox;
    textboxOtherChargeCode: Textbox;
    textboxReeferChargeCode: Textbox;
    textboxReeferSurcharge: Textbox;
    textboxShipperName: Textbox;
}
